var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text"},domProps:{"value":_vm.formattedValue},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":function($event){return _vm.$emit('blur', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }